import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs';
import { GET_SEGMENTS_LIST } from '../graphql/segments.graphql';

export const SegmentsListResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot) => {
  const apollo = inject(Apollo);

  return apollo
    .query({
      query: GET_SEGMENTS_LIST,
      variables: {
        tenantId: route.queryParams['tenant'],
      },
    })
    .pipe(
      map((res: any) => {
        const segments = res.data.segments;
        return segments.length > 0 ? segments : null;
      }),
    );
};
